import { api } from '@wellesley/openapi'
import { handleBasicResponse } from '@wellesley/openapi/helpers'

import {
  setInstanceInfoError,
  setInstanceInfo,
  setInstanceInfoPending,
} from '@wellesley/host-remote/api/actions'

export const instanceInfoApi = api.enhanceEndpoints({
  endpoints: {
    getApiV1Instance: {
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        dispatch(setInstanceInfoPending(true))
        try {
          const response = await handleBasicResponse(queryFulfilled)
          response && dispatch(setInstanceInfo(response.data))
        } catch (e) {
          dispatch(setInstanceInfoError(e))
        } finally {
          dispatch(setInstanceInfoPending(false))
        }
      },
    },
  },
})

export const { useGetApiV1InstanceQuery } = instanceInfoApi
